/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
import PRM from "@/core/PermissionConstants";
export default {
    path: "/app/config/servicios-web",
    name: "WEB-SERVICES",
    component: () => import("@/app/views/crud/CrudSimpleView.vue"),
    meta: {
      service: () => import("@/app/services/WebServicesService"),
      table: () => import("@/app/components/config/webServices/WebServicesTable.vue"),
      form: () => import("@/app/components/config/webServices/WebServicesForm.vue"),
      header: {
        icono: "mdi-search-web",
        texto: "Servicios web",
        textNew: "Nuevo servicio web",
        textEdit: "Editar servicio web",
      },
      prmAdd: PRM.ADD_WEB_SERVICE,
      requireAuth: true,
      hideButtonAdd: false,
      addButtonText: "AGREGAR SERVICIO WEB",
    },
  };